import React from "react";

export const LoginHeader: React.FC = () => {
  return (
    <div className="box-border content-stretch flex flex-col gap-3 items-start justify-start leading-[0] not-italic p-0 relative shrink-0 text-center w-full">
      <div className="font-['Pretendard_Variable'] title-3-bold relative shrink-0 text-primary w-full">
        <p className="block mb-0">XBRL의 시작과 끝</p>
        <p className="block">인벡터에 오신 것을 환영합니다.</p>
      </div>
      <div className="font-['Pretendard_Variable'] label-1-normal-regular relative shrink-0 text-neutral-600 w-full">
        <p className="block mb-0">인벡터에 등록된 이메일과 비밀번호를</p>
        <p className="block">입력하여 로그인하세요.</p>
      </div>
    </div>
  );
};
